import { useNavigate } from "react-router";

import { type IState } from "..";
import { useApi } from "../common";
import {
  apiPlogin,
  apiGtokenInfo,
  rdxUpdateUserInfo,
  apiPpassword,
  apiGtokenRefesh,
  apiPkakaoLogin,
  rdxSetKakaoToken,
} from "./authR";
import { useSelectorEq } from "commons/store/common";
import { useAlert } from "components/popup/popupHook";
import { rdxRemoveCookie } from "commons/cookies/cookiesR";
import { CookieName } from "../../storageVo";
import { useDispatch } from "react-redux";
import { Grade } from "./authVo";
import { getSession, removeSession, setSession } from "commons/storage/storageHook";
import { useEffect, useState } from "react";

export const useGradeUpdate = () => {
  const dispatch = useDispatch();
  return (data: { code: string; name: string; value?: string }) => {
    dispatch(rdxUpdateUserInfo(data));
    setSession("userInfo", JSON.stringify(data));
  };
};

export interface IUseAuthReturn {
  isLogin: boolean;
  name: string;
  role: string;
  userId: number;
  type: string;
  email: string;
  managerName: string;
  cpCode: string | undefined;
  viewType: string | undefined;
  service_type?: string[];
  serviceList?: Array<{ id: string; text: string }>;
  guideFlag?: boolean;
  login: (value?: string, email?: string) => Promise<number>;
  logout: () => Promise<void>;
  getToken: (route?: boolean) => Promise<void>;
  loginCheck: (value?: string) => void;
  errorMessage?: string;
}

export const usePassWord = () => {
  const { password, password_re } = useSelectorEq((state: IState) => ({
    password: state.ui.inputText ? state.ui.inputText["password_id"]! : "",
    password_re: state.ui.inputText ? state.ui.inputText["password_id_re"]! : "",
  }));
  const alert = useAlert();
  const navigate = useNavigate();
  const { apiResult } = useApi();
  return async (pass?: string) => {
    if (password !== "") {
      const re = password_re !== "" || (pass !== undefined && pass !== "");
      if (re) {
        const pre = password_re !== "" ? password_re : pass!;
        if (password === pre) {
          const res = await apiResult(apiPpassword);
          if (res) {
            if (res.code === 200) {
              navigate("/admin/provider");
            }
          }
        } else {
          alert("비밀번호가 다릅니다. 다시 입력해주세요.");
        }
      } else {
        alert("확인할 비밀번호를 입력하세요.");
      }
    } else {
      alert("변경하실 비밀번호를 입력하세요.");
    }
  };
};

export const useTokenRefresh = () => {
  const { apiResult } = useApi();
  const alert = useAlert();
  const { isLogin } = useSelectorEq((state: IState) => ({
    isLogin: state.auth.isLogin,
  }));
  const load = async () => {
    if (isLogin) {
      const res = await apiResult(apiGtokenRefesh);
      if (res?.code !== 200) {
        alert("토큰이 만료되었습니다.<br/> 재 로그인 부탁드립니다.", () => {
          window.location.replace("/");
        });
      }
    }
  };

  useEffect(() => {
    load();

    const intervalId = setInterval(() => {
      load();
    }, 30 * 60 * 1000); // 30분마다 호출 (밀리초 단위)

    return () => {
      clearInterval(intervalId);
    };
  }, [isLogin]);
};
/**
 * user 정보 통신 훅 설정
 */
const useAuth = (): IUseAuthReturn => {
  // 화면상에 표시될 값 설정
  const {
    isLogin,
    name,
    id,
    pwd,
    managerName,
    role,
    email,
    userId,
    cpCode,
    viewType,
    service_type,
    serviceList,
    guideFlag,
  } = useSelectorEq((state: IState) => ({
    isLogin: state.auth.isLogin,
    role: state.auth.role,
    email: state.auth.email,
    name: state.auth.name,
    managerName: state.auth.manager_name,
    userId: state.auth.id,
    id: state.ui.inputText ? state.ui.inputText.login_id : "",
    pwd: state.ui.inputText ? state.ui.inputText.password_id : "",
    cpCode: state.auth.cp_code,
    viewType: state.auth.view_type,
    service_type: state.auth.service_type,
    serviceList: state.auth.serviceList,
    guideFlag: state.auth.guide.viewFlag,
  }));
  const navigate = useNavigate();
  const { apiResult } = useApi();
  const alert = useAlert();
  const dispatch = useDispatch();
  const gradeUpdate = useGradeUpdate();
  /**
   * 로그인 Hook : apiPlogin 를 호출해서 pending, fulfilled, rejected 가 실행되게 처리
   */
  const [click, setClick] = useState<boolean>(false);

  const loginInit = () => {
    if (click && id !== "" && pwd !== "") {
      login();
    }
  };

  const loginCheck = () => {
    setClick(true);
  };

  /**
   * 로그인 function
   * @param value 비밀번호
   * @param eValue 이메일
   * @returns
   */
  const login = async (value?: string, eValue?: string): Promise<number | undefined> => {
    const res = await apiResult(apiPlogin, {
      email: eValue ? eValue : String(id),
      password: value ? value : String(pwd),
    });
    if (res) {
      switch (res.code) {
        case 200:
          getToken();
          if (res.content?.data.is_service) {
            switch (res.content?.data.status) {
              case "dump": //비밀번호를 설정해야하는 상태
                navigate("/password");
                break;
              case "info": //상세정보를 입력해야하는 상태
                if (res.content?.data.role === Grade.MASTER) {
                  navigate("/admin/provider");
                } else if (res.content?.data.role === Grade.ADMIN) {
                  navigate("/admin/setting");
                } else {
                  navigate("/admin/notice");
                }
                break;
              default:
                navigate("/admin/provider");
                break;
            }
          } else {
            navigate("/entry");
          }

          // location.reload();

          return res.code;
        default:
          setClick(false);
          // alert(res.message);
          alert("올바른 이메일 또는 비밀번호를 입력하세요.");
          return res.code;
      }
    } else {
      setClick(false);
      alert("접근오류:: 관리자에게 문의 부탁드립니다.");
      return 999;
    }
    // off();
  };

  const logout = () => {
    dispatch(rdxRemoveCookie(CookieName.AUTH));
    dispatch(rdxRemoveCookie(CookieName.REFRESH));
    const user = getSession("userInfo");
    user && removeSession("userInfo");
    navigate("/");
    location.reload();
  };

  const getToken = async (route?: boolean) => {
    const res = await apiResult(apiGtokenInfo, undefined, logout);
    if (res) {
      switch (res.code) {
        case 200:
          if (!route) {
            const info = getSession("userInfo");
            if (info) {
              gradeUpdate(JSON.parse(info));
            }
          }
          break;
        default:
          navigate("/");
          break;
      }
    } else {
      navigate("/");
    }
  };
  useEffect(() => {
    if (click) {
      loginInit();
    }
  }, [id, pwd, click]);
  return {
    loginCheck,
    isLogin,
    name,
    role,
    email,
    login,
    userId,
    logout,
    getToken,
    managerName,
    cpCode,
    viewType,
    service_type,
    serviceList,
    guideFlag,
  } as IUseAuthReturn;
};

/**
 * 카카오 로그인
 * @returns
 */
export const useKaKaoLogin = () => {
  const navigate = useNavigate();
  const alert = useAlert();
  const { getToken } = useAuth();
  const dispatch = useDispatch();

  const { apiResult } = useApi();

  const kakaoLogin = async (token: string, type: "login" | "signup") => {
    dispatch(rdxSetKakaoToken(token));
    if (type === "login") {
      const res = await apiResult(apiPkakaoLogin);
      if (res) {
        switch (res.code) {
          case 200:
            getToken();
            if (res.content?.data.is_service) {
              switch (res.content?.data.status) {
                case "dump": //비밀번호를 설정해야하는 상태
                  navigate("/password");
                  break;
                case "info": //상세정보를 입력해야하는 상태
                  if (res.content?.data.role !== Grade.MASTER) {
                    navigate("/admin/setting");
                  } else {
                    navigate("/admin/provider");
                  }
                  break;
                default:
                  navigate("/admin/provider");
                  break;
              }
            } else {
              navigate("/entry");
            }
            location.reload();

            return res.code;
          default:
            alert(res.message);
            return res.code;
        }
      } else {
        alert("접근오류:: 관리자에게 문의 부탁드립니다.");
        return 999;
      }
    } else {
      navigate("/signup/kakao");
    }
  };

  return { kakaoLogin };
};

export const useKakaoCliendValue = () => {
  const { id } = useSelectorEq((state: IState) => ({
    id: state.auth.kakao.client_id,
  }));
  return { id };
};

export default useAuth;
